export default __webpack_public_path__ + "static/media/keynote.356bad10.svg";